// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum POST_RESPONSE_TIER {
    critical = 'critical',
    secondary = 'secondary',
}
